import ShopCard from './ShopCard';

export default ShopCard;